module.exports = __webpack_public_path__ + "img/emo_17.59f3f898.png";